import { render, staticRenderFns } from "./performance-development-plan.vue?vue&type=template&id=afaa32ae"
import script from "./performance-development-plan.vue?vue&type=script&lang=js"
export * from "./performance-development-plan.vue?vue&type=script&lang=js"
import style0 from "./performance-development-plan.vue?vue&type=style&index=0&id=afaa32ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports